export default __webpack_public_path__ + "transfix-maps/icons/P3-newWave.649853880d832a1288ebf3bb45ac0024.png";